import React, { ReactElement } from "react";
import TopUpDetailsList from "../../../components/Corporate/TopUp/details";
import Layout from "../../../components/layout";

const TopUpDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <TopUpDetailsList />
    </Layout>
  );
};

export default TopUpDetailsPage;
